<template>
    <div class="auto-settings-banner" v-if="isVisible">
        <h5>{{ $t('optimize_image.components.keep_your_store') }}</h5>
        <p v-html="$t('optimize_image.components.auto_banner_description')"></p>
        <img src="./../assets/auto-optimize-banner.svg" alt=""/>
        <div class="m-t-24 text-right">
            <a-button type="subtle" class="m-r-6" @click="isVisible = false">{{ $t('app.buttons.cancel') }}</a-button>
            <a-button type="primary" @click="setUp">{{ $t('app.buttons.set_up') }}</a-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AutoOptimizeBanner',
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        setUp() {
            this.isVisible = false
            this.$emit('set-up')
        }
    }
}
</script>
<style lang="scss">
    $arrow-size: 5px;
    $arrow-color: $primary-color-light;;
    %arrow {
        &:before {
            position: absolute;
            content: "";
            display: block;
            width: 0;
            height: 0;
            right: 10%;
            top: 0;
            margin-left: -$arrow-size;
            margin-top:-$arrow-size*2;
            border: $arrow-size solid transparent;
            border-bottom: $arrow-size solid $arrow-color;
        }
    }
    .auto-settings-banner {
        width: 425px;
        position: absolute;
        background-color: $primary-color-light;
        font-size: 14px;
        border-radius: 4px;
        padding: 16px 16px 24px 16px;
        top: 45px;
        right: 13%;
        color: $white-color;
        z-index: 1000;
        @extend %arrow;
        .a-btn {
            &-subtle {
                color: $white-color;
                &:hover {
                    color: $text-color;
                }
            }
            &-primary {
                border-color: $white-color;
                background: $white-color;
                color: $primary-color;
            }
        }
        img {
            display: flex;
            margin: auto;
        }
    }
</style>
